<template>
    <div class="emb-testimonial-wrap white section-gap title-gap">
        <div class="container">
            <div class="sec-title text-xl-center">
                <h4>{{ secTitle }}</h4>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['data', 'secTitle'],
    data() {
        return {
            slickOptions: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                arrows: false,
                dots: false,
                swipe: true,
                autoplay: true,
                pauseOnHover: true,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            arrows: false,
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 601,
                        settings: {
                            arrows: false,
                            slidesToShow: 1,
                        },
                    },
                ],
            },
        };
    },
};
</script>
